export const structure = {
  label: 'Gruppe',
  title: 'Unternehmensstruktur',
  subtitle: 'Übersicht über die DR Group und ihre Beteiligungen',
  holdco: {
    name: 'DR Group GmbH',
    type: 'Beteiligungsholding'
  },
  participations: {
    s4chain: {
      name: 'S4Chain GmbH',
      status: 'Operativ',
      description: 'Dienstleistungen werden ausschließlich von S4Chain erbracht',
      link: 'Website besuchen'
    },
    placeholder: 'Weitere Beteiligungen'
  },
  future: {
    title: 'Future PropCo',
    subtitle: 'Konzept-Platzhalter'
  }
};